import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

import reducer from "./reducers";

const middleWare = applyMiddleware(thunk);

export default createStore(reducer, middleWare);


// WEBPACK FOOTER //
// ./src/store.js